import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../Logo";

export const AuthField = ({ label, ...rest }) => (
  <label className="block">
    <span className="mb-2 block font-mono-gd text-[11px] uppercase tracking-[0.25em] text-slate-400">{label}</span>
    <input {...rest} className="w-full rounded-xl border border-[#1E293B] bg-[#0F172A] px-4 py-3.5 text-white outline-none transition-[border-color,box-shadow] placeholder:text-slate-500 focus:border-[#39FF14] focus:shadow-[0_0_0_3px_rgba(57,255,20,0.15)]" />
  </label>
);

export const AuthSubmit = ({ busy, children, busyLabel = "Working…", testid }) => (
  <button data-testid={testid} disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-[#39FF14] py-4 font-semibold text-[#0A0E1A] transition-[box-shadow,transform] hover:shadow-[0_0_40px_rgba(57,255,20,0.4)] active:scale-[0.98] disabled:opacity-60">
    {busy ? busyLabel : children}
  </button>
);

export const AuthError = ({ error, testid = "auth-error" }) =>
  error ? <p data-testid={testid} className="rounded-xl border border-[#FF3B30]/40 bg-[#FF3B30]/10 px-4 py-3 text-sm text-red-200">{error}</p> : null;

export function AuthLayout({ img = "/img/game.jpg", alt = "Basketball game", tagline, children }) {
  return (
    <div className="grain grid min-h-screen bg-[#0A0E1A] lg:grid-cols-2">
      <div className="relative hidden overflow-hidden lg:block">
        <img src={img} alt={alt} className="absolute inset-0 h-full w-full object-cover grayscale contrast-125" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_60%_30%,transparent_0%,rgba(10,14,26,0.6)_45%,#0A0E1A_90%)]" />
        <div className="absolute inset-0 bg-[#39FF14]/10 mix-blend-color" />
        <p className="absolute bottom-12 left-12 max-w-md font-display text-6xl font-black uppercase leading-[0.9] text-white">{tagline}</p>
      </div>
      <div className="relative flex flex-col px-6 py-8 sm:px-12">
        <div className="flex items-center justify-between">
          <Logo />
          <Link to="/" data-testid="auth-back-home" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white"><ArrowLeft className="h-4 w-4" />Home</Link>
        </div>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} className="m-auto w-full max-w-md py-12">
          {children}
        </motion.div>
      </div>
    </div>
  );
}
